var meta = { showLeftMenu: false, headIndex: 2 };
export var router = [
	{
		path: '/diagnoseHome',
		meta: meta,
		name: 'diagnoseHome',
		component: resolve => require(["./diagnoseHome.vue"], resolve)
	},
	{
		path: '/diagnose',
		meta: meta,
		name: 'diagnose',
		component: resolve => require(["./diagnose.vue"], resolve)
	},
	{
		path: '/releaseNotes',
		meta: meta,
		name: 'releaseNotes',
		component: resolve => require(["./releaseNotes.vue"], resolve)
	},
	{
		path: '/diagnoseAnalyse',
		meta: meta,
		name: 'analyse',
		component: resolve => require(["./analyse.vue"], resolve)
	}]



// WEBPACK FOOTER //
// ./src/views/diagnose/router.js